import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { LanguageSelectorComponent } from 'src/app/ui/molecules/language-selector/language-selector.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    TranslateModule,
    RouterOutlet,
    LanguageSelectorComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public showLanguageSelector: boolean;

  constructor(private route: ActivatedRoute, private languageService: LanguageService) {
    this.showLanguageSelector = !environment.production;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.languageService.changeLanguage(lang);
      }
      const showLangSelector = params['showLangSelector'];
      if (showLangSelector) {
        this.showLanguageSelector = showLangSelector === 'true';
      }
    });
  }

}
